export default __webpack_public_path__ + "static/media/0k.ae2d0a4c.png";